export const REPORTLISTING_REQUEST = "REPORTLISTING_REQUEST";
export const REPORTLISTING_SUCCESS = "REPORTLISTING_SUCCESS";
export const REPORTLISTING_FAILURE = "REPORTLISTING_FAILURE";
